<template>
  <div id="persondoc" style="height: 100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "PersonDoc"
};
</script>
